import { InjectionToken } from '@angular/core';
import { IMPORT_DATASET_STATUS } from '@mode/shared/util-js';
import { ActionReducerMap, createReducer, on } from '@ngrx/store';
import * as ReportEditorActions from './report-editor.actions';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { ChartSwitchActions } from '@mode/charts/domain';

export const reportEditorFeatureKey = 'reportEditor';

export interface State {
  selectedQueryToken: string | undefined;
  editorLayout: string | undefined; // the report layout for html editor
  importDatasetResponse: { status: string; switchViewToken: string; vizToken: string | undefined } | string | undefined;
}

export const initialState: State = {
  selectedQueryToken: undefined,
  editorLayout: undefined,
  importDatasetResponse: undefined,
};

export const selectedQueryTokenReducer = createReducer(
  initialState.selectedQueryToken,
  on(ReportEditorActions.selectQuery, (state, action) => action.token),
  on(ReportEditorActions.selectLegacyTable, (state, action) => action.queryToken)
);

export const editorLayoutReducer = createReducer(
  initialState.editorLayout,
  on(ReportEditorActions.updateReportLayout, (state, action) => action.layout)
);

export const importDatasetResponseReducer = createReducer(
  initialState.importDatasetResponse,
  on(ReportEditorActions.importDatasetFailure, (state, action) => ({
    status: action.error,
    switchViewToken: '',
    vizToken: undefined,
  })),
  on(ReportEditorActions.importDatasetSuccess, ChartSwitchActions.importDatasetWithChartSuccess, (state, action) => ({
    status: IMPORT_DATASET_STATUS.Success,
    switchViewToken: action.switchViewToken,
    vizToken: action.vizToken,
  })),
  on(ReportEditorActions.clearImportDatasetResponse, () => undefined)
);

export const reducers = {
  selectedQueryToken: selectedQueryTokenReducer,
  editorLayout: editorLayoutReducer,
  importDatasetResponse: importDatasetResponseReducer,
};

export const reducer = new InjectionToken<ActionReducerMap<State>>('reportEditor reducers token', {
  factory: () => reducers,
});
